/**
 * Swiper slider component
 * 
 * @module swiper-slider
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'swiper-slider';

if(!customElements.get(customElements.component)) {
 
    class SwiperSlider extends HTMLElement {
 
        /**
         * Variant selector web component
         * 
         * @constructor
         */
        constructor() {

            super();

            this.initSlider();
        }

        /**
         * Init options
         * 
         * @return {undefined}
         */
        initOptions() {

            let slidesPerViewMobile = (this.dataset.viewMobile) ? this.dataset.viewMobile : 1.1,
                slidesPerViewMobileExtra = (this.dataset.viewMobileExtra) ? this.dataset.viewMobileExtra : 2.1,
                slidesPerViewTablet = (this.dataset.viewTablet) ? this.dataset.viewTablet : 3.1,
                slidesPerViewTabletExtra = (this.dataset.viewTabletExtra) ? this.dataset.viewTabletExtra : 3,
                slidesPerViewDesktop = (this.dataset.viewDesktop) ? this.dataset.viewDesktop : 4,
                swiperPagination = this.querySelector('.swiper-pagination'),
                swiperScrollbar = this.querySelector('.swiper-scrollbar'),
                spaceBetween = (this.dataset.viewSpaceBetween) ? parseInt(this.dataset.viewSpaceBetween) : null,
                spaceBetweenMobile = (this.dataset.viewSpaceBetweenMobile) ? parseInt(this.dataset.viewSpaceBetweenMobile) : null,
                dataOffBefore = (this.dataset.offBefore) ? parseInt(this.dataset.offBefore) : 40,
                dataOffAfter = (this.dataset.offAfter) ? parseInt(this.dataset.offAfter) : 40,
                dataOffBeforeMobile = (this.dataset.offBeforeMobile) ? parseInt(this.dataset.offBeforeMobile) : 16,
                dataOffAfterMobile = (this.dataset.offAfterMobile) ? parseInt(this.dataset.offAfterMobile) : 16, 
                
                centerInsufficientSlides = (this.dataset.centerInsufficientSlides) ? this.dataset.centerInsufficientSlides : false,
                centeredSlides = (this.dataset.centeredSlides) ? this.dataset.centeredSlides : false,
                
                nextButtonClass = this.dataset.nextButtonClass ?? this.querySelector('.swiper-button-next') ?? '.swiper-button-next',
                prevButtonClass = this.dataset.prevButtonClass ?? this.querySelector('.swiper-button-prev') ?? '.swiper-button-prev';

            swiperPagination = (swiperPagination) ? swiperPagination : '.swiper-pagination';
            swiperScrollbar = (swiperScrollbar) ? swiperScrollbar : '.swiper-scrollbar';

            let defaultOptions = {
                slidesPerView: slidesPerViewMobile,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                spaceBetween: (spaceBetweenMobile !== null) ? spaceBetweenMobile : spaceBetween,
                slidesOffsetBefore: dataOffBeforeMobile !== undefined && dataOffBeforeMobile !== '' ? parseInt(dataOffBeforeMobile) : 16,
                slidesOffsetAfter: dataOffAfterMobile !== undefined && dataOffAfterMobile !== '' ? parseInt(dataOffAfterMobile) : 16,
                centerInsufficientSlides: centerInsufficientSlides,
                centeredSlides: centeredSlides,
                pagination: {
                    el: swiperPagination,
                    dynamicBullets: true
                },
                navigation: {
                    nextEl: nextButtonClass,
                    prevEl: prevButtonClass
                },
                scrollbar: {
                    el: swiperScrollbar
                },
                breakpoints: {
                    600: {
                      slidesPerView: slidesPerViewMobileExtra
                    },
                    750: {
                      slidesPerView: slidesPerViewTablet,
                      spaceBetween: (spaceBetween !== null) ? spaceBetween : 20,
                    },
                    900: {
                      slidesPerView: slidesPerViewTabletExtra,
                      spaceBetween: (spaceBetween !== null) ? spaceBetween : 20,
                      slidesOffsetBefore: dataOffBefore,
                      slidesOffsetAfter: dataOffAfter,
                    },
                    1200: {
                        slidesPerView: slidesPerViewDesktop,
                        slidesOffsetBefore: dataOffBefore,
                        slidesOffsetAfter: dataOffAfter,
                        spaceBetween: (spaceBetween !== null) ? spaceBetween : 20,
                    }
                },
                on: {
                    init: () => {
                        this.checkOverflow();
                    },
                    slideChange: () => {
                        this.checkOverflow();
                    },
                    imagesReady: () => {
                        this.classList.add('swiper-loaded');
                        this.checkOverflow();
                    },
                }
            };

            let options = (this.dataset.options) ? JSON.parse(this.dataset.options) : {};

            this.options = {...defaultOptions, ...options};
        
            this.options;
        }

        checkOverflow() {
          const wrapper = this.querySelector('.swiper-wrapper');
          const nextBtn = this.querySelector('.swiper-button-next');
          const prevBtn = this.querySelector('.swiper-button-prev');

          if (!wrapper || !nextBtn || !prevBtn) return;

          const wrapperWidth = wrapper.scrollWidth;
          const containerWidth = this.clientWidth;

          if (wrapperWidth <= containerWidth + 2) {
            nextBtn.style.display = 'none';
            prevBtn.style.display = 'none';
          } else {
            nextBtn.style.display = '';
            prevBtn.style.display = '';
          }
        }

        /**
         * Init slider
         * 
         * @return {undefined}
         */
        initSlider() {

            this.initOptions();

            this.slider = new Swiper(this, this.options);
        }

        /**
         * Destroy slider
         *
         * @return {undefined}
         */
        destroySlider() {
          this.slider.destroy();
        }
        
        /**
         * Reinitialize slider
         *
         * @return {undefined}
         */
        reinitSlider() {
            this.destroySlider();
            this.initSlider();
        }
       
    }
 
    customElements.define(customElements.component, SwiperSlider);
}
 